export default "__VITE_ASSET__DIxVcEzG__"